﻿export * from './scripts.component';